/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { AppEvents } from '../../types/common/AppEvents';
import { INotification, NotificationsActions, NotificationsActionTypes } from './types';

export const addNotification = (notification: INotification): NotificationsActionTypes => ({
  type: NotificationsActions.ADD_NOTIFICATION,
  payload: { notification },
});

export const setNotifications = (options: INotification<AppEvents>[]): NotificationsActionTypes => ({
  type: NotificationsActions.SET_NOTIFICATIONS,
  payload: { options },
});

export const setNotificationRead = (params: { id: string; isRead: boolean }): NotificationsActionTypes => ({
  type: NotificationsActions.SET_NOTIFICATION_READ,
  payload: params,
});

export const setNotificationsRead = (params?: { isRead: boolean }): NotificationsActionTypes => ({
  type: NotificationsActions.SET_NOTIFICATIONS_READ,
  payload: { isRead: params?.isRead || true },
});

export const removeNotification = ({ id }: { id: string }): NotificationsActionTypes => ({
  type: NotificationsActions.REMOVE_NOTIFICATION,
  payload: { id },
});
